import { render, staticRenderFns } from "./CodeView.vue?vue&type=template&id=177a8dcc&"
import script from "./CodeView.vue?vue&type=script&lang=js&"
export * from "./CodeView.vue?vue&type=script&lang=js&"
import style0 from "./CodeView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports